import { Injectable } from "@angular/core";
import { Messenger, NotificationHelper } from "@app/shared";
import { NotificationDto } from "../data";

@Injectable({
    providedIn: 'root'
})

export class NotificationFactory {
    constructor(private messenger: Messenger) {}
    public createNotification(notification: NotificationDto){

       
        let notificationType = this.messenger.getType(notification.type) || NotificationHelper.getNotificationTypeByName(notification.type);
        let payload = notification.data;
        
        if (!notificationType)
        {
            
            return undefined;
        }

        let actualNotification = Reflect.construct(notificationType, []) as any;

        if (payload) {
            Object.assign(actualNotification, payload);
        }
         actualNotification.id = notification.id;
        actualNotification.sender = notification.sender;
        actualNotification.createdDate = notification.createdDate;
        actualNotification.isDismissable = notification.isDismissable;
        
        
        return actualNotification;
    }
}